export default {

  columns: (state) => {
    const list = {};

    state.records.forEach((v, k) => {
      const index = k < state.grid_columns ? k : (k % state.grid_columns);

      if (!list[index]) {
        list[index] = [];
      }

      list[index].push(v);
    });

    return list;
  },

};



// WEBPACK FOOTER //
// ./src/store/ads/ads.getters.js